import { clsx } from 'clsx';

import { ItemOfOrderTotals } from './components';

import makeClasses from './TotalsSection.style';

import type { OrderTotals } from 'shared/domain';
import type { HTMLAttributes, ReactNode } from 'react';

export function TotalsSection(props: Props) {
  const {
    titleErrorProps,
    titleMsgError,
    mainContainerProps,
    totals,
    children,
  } = props;

  const _classes = makeClasses();

  return (
    <section aria-label='totals-section' className={_classes.section}>
      <h4 className={_classes.error} {...titleErrorProps}>
        {titleMsgError}
      </h4>

      <main {...mainContainerProps}>
        {totals.detail.item.subtotal && (
          <ItemOfOrderTotals
            className={_classes.item}
            item={totals.detail.item.subtotal}
          />
        )}
        {totals.detail.item.discountPartnerStore && (
          <ItemOfOrderTotals
            className={_classes.item}
            item={totals.detail.item.discountPartnerStore}
          />
        )}
        {totals.detail.item.totalStore && (
          <ItemOfOrderTotals
            className={clsx(_classes.item, 'bold')}
            item={totals.detail.item.totalStore}
          />
        )}
        {totals.detail.item.discountRappi && (
          <ItemOfOrderTotals
            className={_classes.item}
            item={totals.detail.item.discountRappi}
          />
        )}
        {totals.detail.item.suggestedTotal && (
          <ItemOfOrderTotals
            className={clsx(_classes.item, 'bold')}
            item={totals.detail.item.suggestedTotal}
          />
        )}
        {totals.detail.extraItems.map(detail => (
          <ItemOfOrderTotals
            key={detail.id}
            item={detail}
            className={_classes.item}
          />
        ))}
        {totals.detail.item.totalDiscount && (
          <ItemOfOrderTotals
            className={_classes.item}
            item={totals.detail.item.totalDiscount}
          />
        )}
        <ItemOfOrderTotals
          aria-label='totals-main-item'
          item={totals.main}
          className={clsx(_classes.item, 'bold')}
        />

        {children}
      </main>
    </section>
  );
}

interface Props {
  titleErrorProps: Partial<HTMLAttributes<HTMLHeadingElement>>;
  titleMsgError: string;
  mainContainerProps: Partial<HTMLAttributes<HTMLElement>>;
  totals: OrderTotals;
  children?: ReactNode | ReactNode[];
}
